require("./src/styles/global.scss");


export const onClientEntry = () => {
  window.addEventListener("LC_chatWidgetLoaded", () => {
    const host = document.querySelector("chat-widget");
    if (!host?.shadowRoot) return;

    const shadow = host.shadowRoot;

    const styleTag = document.createElement("style");
    styleTag.textContent = `
      @media (max-width: 767px) {
        #lc_text-widget,
        #lc_text-widget--btn {
          bottom: 60px !important;
        }
      }
    `;
    shadow.appendChild(styleTag);

    const observer = new MutationObserver(() => {
      if (!shadow.contains(styleTag)) {
        shadow.appendChild(styleTag);
      }
    });

    observer.observe(shadow, { childList: true, subtree: true });
  });
};

export const onRouteUpdate = () => {
    updatePreloader();
}

function updatePreloader() {
    const preloader = (typeof document !== `undefined` ? document.querySelector('.preloader'): null)
    
    if (preloader !== undefined) {
        setTimeout(() => {
            try {
                preloader.classList.add('hide-preloader');
            } catch(e) {
                console.log(e);
            }
        }, 0);
    
            setTimeout(() => {
                try {
                    preloader.remove();
                } catch (e) {
                    console.log(e);
                }
            }, 1000)
        }
    
}